module.exports = __webpack_public_path__ + "img/generalbuilder.0f420224.png";